export const getFileExtension = (url: string) => ((url.indexOf('.') == -1) ? "" : url.split(".").pop());